import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Avatar from "module-common/Avatar";
import Icon from "module-common/Icon";
import Button from "module-common/Button";
import Picker from "module-common/PickerAgentWithQuery";
import Modal from "module-common/ConfirmModal";
import CaseNotes from "./CaseNotes";
import { LivechatOnlineStatusStore, CaseManagementStore } from "Store";
import { Channels, Graphics } from "constant";
import { observer } from "mobx-react";

function ColorFromStatus(status) {
  if (status) {
    return "onlineStatus";
  } else {
    return "offlineStatus";
  }
}

export default observer(
  class HeaderView extends Component {
    static propTypes = {
      image: PropTypes.string,
      channel: PropTypes.string,
      channelName: PropTypes.string,
      name: PropTypes.string,
      notes: PropTypes.string,
      showAssignToOtherButton: PropTypes.bool,
      showCloseButton: PropTypes.bool,
      showUnassignButton: PropTypes.bool,
      showInfo: PropTypes.bool,
      showCloseNotes: PropTypes.bool,
      onAssignToOther: PropTypes.func,
      onCloseCase: PropTypes.func,
      onUnassign: PropTypes.func,
      onOpenInfoPanel: PropTypes.func,
      status: PropTypes.string
    };
    static defaultProps = {
      name: "Lorem Ipsum"
    };
    state = {
      showCloseModal: false,
      isOnline: false
    };
    render() {
      const store = this.props.store || CaseManagementStore
      const caseStore = store.selectedCase.customerChannelHandler;
      const LivechatStore = LivechatOnlineStatusStore;
      const {
        image,
        channel,
        channelName,
        name,
        notes,
        showAssignToOtherButton,
        showCloseButton,
        showUnassignButton,
        showInfo,
        showCloseNotes,
        onCloseCase,
        onUnassign,
        status
      } = this.props;
      const { showCloseModal, isOnline } = this.state;

      const assignToOtherButton = showAssignToOtherButton && (
        <AgentPicker onSelected={this.onSelected}>
          <Button color="transparent" size="medium" border>
            Assign to other
          </Button>
        </AgentPicker>
      );

      const closeButton = showCloseButton && (
        <Button
          color="transparent"
          size="medium"
          border
          onClick={this.showModal}
        >
          Close Case
        </Button>
      );

      const unassignButton = showUnassignButton && (
        <Button color="transparent" size="medium" border onClick={onUnassign}>
          Unassign
        </Button>
      );

      const closeNotes = showCloseNotes && (
        <Button
          color="transparent"
          size="medium"
          border
          onClick={this.showModal}
        >
          Show Close Notes
        </Button>
      );
      return (
        <Header>
          {channel === "livechat" ? (
            <StatusWrapper
              color={
                caseStore.id === LivechatStore.originalId
                  ? ColorFromStatus(LivechatOnlineStatusStore.isOnline)
                  : ColorFromStatus(false)
              }
            >
              <Avatar image={image} channel={channel} isSmall />
            </StatusWrapper>
          ) : (
            <Avatar image={image} channel={channel} isSmall />
          )}
          <Name>{name}</Name>
          <ChannelName>to {channelName}</ChannelName>
          {assignToOtherButton}
          {closeButton}
          {unassignButton}
          {closeNotes}
          {showCloseModal &&
            (showCloseNotes === true ? (
              <CaseNotes content={this.props.notes} onClose={this.hideModal} />
            ) : (
              <Modal
                text="Do you want to close this case?"
                withNote={true}
                onCancel={this.hideModal}
                onConfirm={onCloseCase}
              />
            ))}
          <Icon
            name={showInfo ? "info-selected" : "info-off"}
            onClick={this.props.onOpenInfoPanel}
            width={showInfo ? 36 : 18}
            height={showInfo ? 31 : 18}
          />
        </Header>
      );
    }

    showModal = () => {
      this.setState({ showCloseModal: true });
    };

    hideModal = () => {
      this.setState({ showCloseModal: false });
    };

    onSelected = agent => {
      const onAssignToOther = this.props.onAssignToOther;
      if (onAssignToOther) onAssignToOther(agent.value.id);
    };
  }
);

const Header = styled.div`
  display: flex;
  flex: none;
  height: 45px;
  padding: 0 10px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d2d3d5;
  & > button {
    margin-right: 4px;
  }
`;

const StatusWrapper = styled.div`
  background: #4fe47d;
  border-radius: 50%;
  padding: 3px;
  ${props =>
    props.color &&
    css`
      background-color: ${props.theme[props.color]};
    `};
`;
const Name = styled.div`
  margin-left: 10px;
  color: #555;
  font-weight: 700;
  font-size: 14px;
`;
const AgentPicker = styled(Picker)`
  margin-right: 4px;
`;
const ChannelName = styled.div`
  margin-right: auto;
  margin-left: 5px;
  color: #8a8a8a;
  font-weight: 400;
  font-size: 12px;
  padding-top: 4px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/header/HeaderView.js